import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Alert, Button, CircularProgress, Container, Stack } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { useGetCorridorOpportunity } from '~/hooks/apis/flights/useCorridorOpportunities';
import useQuery from '~/hooks/useQuery';

import CampaignPublication from './CampaignPublication';
import OpportunityBuildReview from './OpportunityBuildReview';

export default function CampaignBuilderPage() {
  const opportunityId = useQuery().get('opportunityId') ?? undefined;
  const opportunity = useGetCorridorOpportunity(opportunityId);
  return (
    <Container maxWidth="xl">
      <PageHeader title="Review generated campaign and deal" backButton />
      <Stack gap={3}>
        {!opportunityId && <Alert severity="info">Choose a generated draft from Flight Opportunities.</Alert>}
        {opportunity.isLoading && <CircularProgress />}
        {opportunity.isError && (
          <Alert severity="error">The opportunity could not be loaded. Return to Opportunities and retry.</Alert>
        )}
        {opportunity.data &&
          !opportunity.isError &&
          (opportunity.data.campaignId ? (
            <CampaignPublication campaignId={opportunity.data.campaignId} />
          ) : (
            <OpportunityBuildReview
              key={`${opportunityId}:${opportunity.data.campaignDraft?.sourceValidationId}:${opportunity.data.campaignDraft?.generatedAt}`}
              opportunity={opportunity.data}
            />
          ))}
        <Button component={Link} to="/flights/opportunities">
          Back to opportunities
        </Button>
      </Stack>
    </Container>
  );
}
